/**
 * ScrollToTop component - Scrolls to top on route change
 */

import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function ScrollToTop() {
  const {pathname, hash} = useLocation();

  useEffect(() => {
    // If there's a hash fragment, scroll to that element instead of top
    if (hash) {
      const timer = setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const offset = 100; // Account for fixed navbar
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            left: 0,
            behavior: 'smooth',
          });
        }
      }, 100); // Small delay to ensure DOM is ready
      
      return () => clearTimeout(timer);
    } else {
      // No hash - scroll to top when route changes
      // Use setTimeout to ensure DOM is ready
      const timer = setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // Use 'instant' for immediate scroll, 'smooth' for animated
        });
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [pathname, hash]);

  return null;
}

